(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slider-gallery')) {
    customElements.define(
      'slider-gallery',
      class SliderGallery extends HTMLElement {
        connectedCallback() {
          if (this._sgBound) {
            window.addEventListener('resize', this.onResize, { passive: true });
            if (this._ro) this._ro.observe(this);
            this.render();
            this.startAutoplay();
            return;
          }
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;
          this.slides = Array.from(this.track.querySelectorAll('.slider-gallery__slide'));
          this.count = this.slides.length;
          if (this.count === 0) return;

          this.active = 0;
          this.dragOffset = 0;
          this.step = 1;
          this._maxMove = 0;
          this._downIndex = -1;

          this.scope = this.closest('.shopify-section') || this;
          this.prevBtn = this.scope.querySelector('[data-prev]');
          this.nextBtn = this.scope.querySelector('[data-next]');

          this.onResize = () => this.render();
          window.addEventListener('resize', this.onResize, { passive: true });
          // Recover if the card width resolves to 0 at first paint (e.g. the
          // section starts inside a hidden ancestor that is later revealed).
          if (window.ResizeObserver) {
            this._ro = new ResizeObserver(() => this.render());
            this._ro.observe(this);
          }
          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));

          this.bindDrag();
          this.bindClick();
          this.bindKeys();

          // Pause autoplay on hover — but only for real mouse pointers. Using a
          // flag (not :hover) avoids the sticky-:hover bug that would otherwise
          // freeze autoplay on touch devices after the first tap.
          this._paused = false;
          if (window.matchMedia('(hover: hover)').matches) {
            this.addEventListener('pointerenter', (e) => {
              if (e.pointerType === 'mouse') this._paused = true;
            });
            this.addEventListener('pointerleave', (e) => {
              if (e.pointerType === 'mouse') this._paused = false;
            });
          }

          this._sgBound = true;
          this.setAttribute('data-ready', '');
          // Render immediately, then again next frame once the card width has
          // settled. (rAF is paused in background tabs, so don't rely on it alone.)
          this.render();
          requestAnimationFrame(() => this.render());
          this.startAutoplay();
        }

        disconnectedCallback() {
          this.stopAutoplay();
          window.removeEventListener('resize', this.onResize);
          if (this._ro) this._ro.disconnect();
          if (this._dragMove) document.removeEventListener('pointermove', this._dragMove);
          if (this._dragEnd) {
            document.removeEventListener('pointerup', this._dragEnd);
            document.removeEventListener('pointercancel', this._dragEnd);
          }
          this.classList.remove('is-dragging');
          this.dragOffset = 0;
          this._maxMove = 0;
          this._downIndex = -1;
        }

        mod(i) {
          const n = this.count;
          return ((i % n) + n) % n;
        }

        // Signed shortest distance from active, in [-n/2, n/2], for the infinite loop.
        wrap(d) {
          const n = this.count;
          d = ((d % n) + n) % n;
          if (d > n / 2) d -= n;
          return d;
        }

        config() {
          const cs = getComputedStyle(this);
          const side = Math.max(1, parseInt(cs.getPropertyValue('--sg-side'), 10) || 1);
          const stepFactor = parseFloat(cs.getPropertyValue('--sg-step-factor')) || 0.74;
          const scaleDrop = parseFloat(cs.getPropertyValue('--sg-scale-drop')) || 0.16;
          const cardW = (this.slides[0] && this.slides[0].offsetWidth) || this.track.clientWidth || 1;
          return { side, stepFactor, scaleDrop, cardW };
        }

        render() {
          // Config only changes on resize, never mid-drag — reuse the cached
          // values while dragging so pointermove doesn't force a layout flush.
          if (!this._cfg || !this.classList.contains('is-dragging')) {
            this._cfg = this.config();
          }
          const { side, stepFactor, scaleDrop, cardW } = this._cfg;
          const step = cardW * stepFactor;
          this.step = step;
          const minScale = Math.max(0.4, 1 - (side + 1) * scaleDrop);

          this.slides.forEach((slide, i) => {
            const rel = this.wrap(i - this.active);
            const a = Math.abs(rel);

            if (a > side + 1) {
              // Park just out of view so it can glide in later.
              slide.style.opacity = '0';
              slide.style.pointerEvents = 'none';
              slide.style.zIndex = '0';
              slide.style.transform =
                'translate(-50%, -50%) translateX(' + (rel < 0 ? -1 : 1) * step * (side + 1) + 'px) scale(' + minScale + ')';
              slide.setAttribute('aria-hidden', 'true');
              slide.classList.remove('is-active');
              return;
            }

            const x = rel * step + this.dragOffset;
            const scale = Math.max(0.4, 1 - a * scaleDrop);
            const onStage = a <= side;
            const isCenter = rel === 0;

            slide.style.transform = 'translate(-50%, -50%) translateX(' + x + 'px) scale(' + scale + ')';
            slide.style.zIndex = String(100 - a);
            slide.style.opacity = onStage ? (a === side && side >= 2 ? '0.55' : '1') : '0';
            slide.style.pointerEvents = onStage ? 'auto' : 'none';
            slide.setAttribute('aria-hidden', onStage ? 'false' : 'true');
            slide.classList.toggle('is-active', isCenter);
          });
        }

        go(dir) {
          this.stopAutoplay();
          this.active = this.mod(this.active + dir);
          this.render();
          this.startAutoplay();
        }

        goTo(index) {
          this.stopAutoplay();
          this.active = this.mod(index);
          this.render();
          this.startAutoplay();
        }

        bindDrag() {
          let startX = 0;
          let dragging = false;

          const move = (e) => {
            if (!dragging) return;
            const dx = e.clientX - startX;
            if (Math.abs(dx) > this._maxMove) this._maxMove = Math.abs(dx);
            this.dragOffset = dx;
            this.render();
          };

          const up = () => {
            if (!dragging) return;
            dragging = false;
            this.classList.remove('is-dragging');
            document.removeEventListener('pointermove', move);
            document.removeEventListener('pointerup', up);
            document.removeEventListener('pointercancel', up);
            const dx = this.dragOffset;
            this.dragOffset = 0;
            const threshold = Math.max(40, this.step * 0.22);
            if (dx <= -threshold) {
              this.active = this.mod(this.active + Math.max(1, Math.round(-dx / this.step)));
            } else if (dx >= threshold) {
              this.active = this.mod(this.active - Math.max(1, Math.round(dx / this.step)));
            }
            this.render();
            this.startAutoplay();
          };
          this._dragMove = move;
          this._dragEnd = up;

          this.track.addEventListener('pointerdown', (e) => {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            dragging = true;
            this._maxMove = 0;
            startX = e.clientX;
            this.dragOffset = 0;
            this._downIndex = this.slides.indexOf(e.target.closest('.slider-gallery__slide'));
            this.classList.add('is-dragging');
            this.stopAutoplay();
            // Listen on document so a mouse drag keeps tracking even if the pointer
            // leaves the gallery. Intentionally NOT using setPointerCapture: on
            // Chromium it retargets the follow-up click to the captured element,
            // which broke click-to-focus on desktop.
            document.addEventListener('pointermove', this._dragMove);
            document.addEventListener('pointerup', this._dragEnd);
            document.addEventListener('pointercancel', this._dragEnd);
          });
        }

        bindClick() {
          this.track.addEventListener('click', (e) => {
            // A real drag (moved past the tap tolerance) shouldn't navigate or re-center.
            if (this._maxMove > 10) {
              e.preventDefault();
              this._maxMove = 0;
              this._downIndex = -1;
              return;
            }
            // Use the card that was pressed (the click target can be unreliable),
            // falling back to the click target's slide.
            let i = this._downIndex;
            if (i < 0) {
              const slide = e.target.closest('.slider-gallery__slide');
              i = slide ? this.slides.indexOf(slide) : -1;
            }
            this._downIndex = -1;
            if (i < 0) return;
            // Click a card that isn't focused -> bring it to the front (don't follow its link).
            if (this.wrap(i - this.active) !== 0) {
              e.preventDefault();
              this.goTo(i);
            }
            this._maxMove = 0;
          });
        }

        bindKeys() {
          this.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
              this.go(-1);
            } else if (e.key === 'ArrowRight') {
              this.go(1);
            }
          });
        }

        startAutoplay() {
          this.stopAutoplay();
          if (this.dataset.autoplay !== 'true') return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const interval = parseInt(this.dataset.autoplayInterval, 10) || 5000;
          this.timer = setInterval(() => {
            if (this._paused) return;
            this.active = this.mod(this.active + 1);
            this.render();
          }, interval);
        }

        stopAutoplay() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
